import { createStore } from 'vuex'

export default createStore({
  state: {
    devMode: false,
    skipForm: false,
    ordernumber: '',
    urlToSend: '/api/apartment-and-house-insurance-light/send-info', //урл куда посылать форму
    sendResponse: {},
    urlToSendSmsCode: '/api/apartment-and-house-insurance-light/get-code',
    urlToCheckSmsCode: '/api/apartment-and-house-insurance-light/confirm-code', //урл для проверки смс кода
    urlToPay: '/api/apartment-and-house-insurance-light/get-pay-link ',
    DaDataToken: 'd19d3963dafe68db009a421b3baaf979385ab67b',
    dadata_urls: {
      fio: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/fio',
      address: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address'
    },
    loads: {},
    form: {
      tariff: 'Тариф Лайт',
      address: {
        city: '',
        street: '',
        nostreet: false,
        house: '',
        flat: '',
        dadataChosen: {
          city: null,
          street: null,
          house: null
        }
      },
      personal: {
        name: '',
        surname: '',
        patronymic: '',
        birthdate: '',
        sex: '',
        birthplace: '',
      },
      passport: {
        number: '',
        releasedate: '',
      },
      contacts: {
        tel: '',
        email: ''
      },
      agreement: false
    },
    sendedSuccessfully: false,
    thanksshow: false,
    errorMessage: {
      show: false,
      title: '',
      text: '',
      btnText: '',
    },
    popperOptions: {
      modifiers: [
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['bottom', 'top'],
          },
        },
        {
          name: 'preventOverflow',
          options: {
            altAxis: true,
            tether: false,
          },
        },
      ],
    },
  },
  getters: {
    loading(state) {
      return Object.keys(state.loads).length ? true : false
    },
  },
  mutations: {
    setOrdernumber(state,val) {
      state.ordernumber = val
    },
    setSendResponse(state, val) {
      state.sendResponse = val
    },
    setSendedSuccessfully(state, val) {
      state.sendedSuccessfully = val
    },
    setThanksShow(state, val) {
      state.thanksshow = val
    },
    setErrorMessage(state, val) {
      if (!val || !val.title) {
        console.error('Неверное значение errorMessage: ')
        console.error(val)
      } else
        state.errorMessage = { show: true, ...val }
    },
    hideErrorMessage(state) {
      state.errorMessage.show = false
    },
    addLoad(state, val) {
      state.loads[val] = (state.loads[val] || 0) + 1
    },
    removeLoad(state, val) {
      if (state.loads[val]) {
        if (state.loads[val] == 1)
          delete state.loads[val]
        else
          state.loads[val]--
      }
    },
  },
  actions: {
    async sendForm({ state, commit, dispatch }) {
      commit('addLoad', 'sendForm')
      let ok = await dispatch('serverRequest', {
        url: state.urlToSend,
        body: state.form,
        onSuccess: (json) => {
          if (json.guid && json.policyUrl)
            commit('setSendResponse', json)
          else
            throw ('Неверный формат ответа сервера')
        }
      })
      commit('removeLoad', 'sendForm')
      return ok
    },
    success({ commit }, ordernumber) {
      commit('setThanksShow', true)
      commit('setSendedSuccessfully', true)
      commit('setOrdernumber', ordernumber)
    },
    processError({ commit }, err) {
      if (!err)
        return
      try {
        let processed_err = {
          title: 'Ошибка!',
          text: err.messages.map(el => el.message).join('<br><br>'),
          btnText: 'Ок'
        }
        commit('setErrorMessage', processed_err)
        return true
      } catch (err) {
        console.error(err)
        commit('setErrorMessage', {
          title: 'Ошибка!',
          text: 'Что-то пошло не так',
          btnText: 'Ок'
        })
        return false
      }
    },
    async serverRequest({state, commit, dispatch}, { url, body = {}, onSuccess, guid }) {
      if (state.devMode)
        return true
      if (guid && state.sendResponse.guid)
        body.guid = state.sendResponse.guid
      return await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })
        .then(res => {
          if (!res.ok)
            throw ({
              title: 'Ошибка!',
              text: 'Приносим свои извинения! <br>На сервере ведутся технические работы. <br>Попробуйте обратиться к сервису позже',
              btnText: 'Ок'
            })
          return res.json()
        })
        .then(json => {
          if (json.status == "OK") {
            if (onSuccess)
              onSuccess(json)
            return true
          }
          dispatch('processError', json)
          return false
        })
        .catch(err => {
          console.error(err)
          if (err?.title)
            commit('setErrorMessage', err)
          else
            commit('setErrorMessage', ({
              title: 'Ошибка!',
              text: 'Что-то пошло не так',
              btnText: 'Ок'
            }))
          return false
        })
    }
  },
  modules: {
  }
})
